import api from '~/services/api';

function getAllServiceLevels() {
  return api.request({
    url: `/api_account/service_levels`,
    method: 'GET',
    params: {
      use_database: true,
    },
  });
}

export { getAllServiceLevels };
